module.exports = __webpack_public_path__ + "static/img/s-creditCard.b99c4d96.svg";